export default __webpack_public_path__ + "static/media/icon-arrow-down.a335ae6b.svg";